import React from "react";

// React bubbles clicks from portaled menus and sheets here too, so only bare in-item clicks select.
export const selectOnBareClick =
  (select: () => void) => (event: React.MouseEvent<HTMLElement>) => {
    const target = event.target as Element;
    if (!event.currentTarget.contains(target) || target.closest("button, a")) {
      return;
    }
    select();
  };
